import React from 'react';
import { motion } from 'framer-motion';
import type { StepGroup } from '../../types/application';
interface MobileProgressProps {
  groups: StepGroup[];
  activeStep: string;
  completed: string[];
}
export function MobileProgress({
  groups,
  activeStep,
  completed
}: MobileProgressProps) {
  const activeGroup = groups.find(g => g.steps.some(s => s.id === activeStep));
  const activeIdx = activeGroup ? activeGroup.steps.findIndex(s => s.id === activeStep) : 0;
  const next = groups[groups.findIndex(g => g.id === activeGroup?.id) + 1];
  return <div className="lg:hidden" data-id="element-32" data-mp="3qghn1wy2bnr6">
      <div className="flex gap-1" aria-hidden data-id="element-33" data-mp="890jdte7jheg">
        {groups.map(g => {
        const done = g.steps.filter(s => completed.includes(s.id)).length;
        const isActive = g.id === activeGroup?.id;
        const pct = isActive ? (activeIdx + 0.5) / g.steps.length * 100 : done / g.steps.length * 100;
        return <div key={g.id} className="h-1 flex-1 overflow-hidden rounded-full bg-ink-200" data-id="element-34" data-mp="25zuuwjymwb67">
              <motion.div className={`h-full rounded-full ${isActive ? 'bg-pulse-600' : 'bg-pulse-300'}`} animate={{
            width: `${pct}%`
          }} transition={{
            duration: 0.4,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-35" data-mp="3ckrxoqjq2flt" />
            </div>;
      })}
      </div>
      <div className="mt-3 flex items-center justify-between text-[13px]" data-id="element-36" data-mp="3r8382p463tkc">
        <span className="font-medium text-ink-900" data-id="element-37" data-mp="3ra69e5art94d">
          {activeGroup?.label}
          {activeGroup && activeGroup.steps.length > 1 && <span className="ml-1.5 font-normal text-ink-400" data-id="element-38" data-mp="42m1k573v5uv">
              {activeIdx + 1}/{activeGroup.steps.length}
            </span>}
        </span>
        {next && <span className="text-ink-400" data-id="element-39" data-mp="e1jk8rhuo55y">Next: {next.label}</span>}
      </div>
    </div>;
}